module.exports = __webpack_public_path__ + "static/media/login-step-1.3ac8acd4.png";